import { Col, Row } from 'antd';
import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import Enums from 'utils/EnumsManager';
import CardBackGround from './cardBackGround';


const { ObjectTypes, Today } = Enums;
const { Leads, Accounts, Opportunities } = ObjectTypes;

class TodayTag extends React.Component {
  handleViewMore = (objectType) => {
    const { history, setRouteInfo } = this.props;
    setRouteInfo(objectType);
    history.push(`/${objectType}`);
  }

  render() {
    const { intl, todayNewTotal } = this.props;
    const { formatMessage } = intl;
    const types = [Leads, Accounts, Opportunities];
    const renderCard = types.map(type => (
      <Col span={8} key={type}>
        <CardBackGround
          type={type}
          time={Today}
          titleText={formatMessage({ id: `page.dashboard.new${type}` })}
          totalNumber={todayNewTotal[type]}
          action={this.handleViewMore}
          btnText={formatMessage({ id: 'page.dashboard.viewMore' })}
        />
      </Col>
    ));

    return (
      <Row gutter={8}>
        {renderCard}
      </Row>
    );
  }
}

export default withRouter(injectIntl(TodayTag));



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/leftTopModal/todayTag.jsx